// import React, { useRef, useState } from 'react';
// import './Profile.css';
// import TripPreview from '../components/TripPreview';
// import Swal from 'sweetalert2';
// import { doc, getFirestore, setDoc } from 'firebase/firestore';
// import { useDocumentData } from 'react-firebase-hooks/firestore';
// import EditUserProfile from '../components/EditUserProfile';
// import { IconButton } from '@mui/material';
// import dayjs from 'dayjs';
// import CachedImage from '../components/CachedImage';
// import EditIcon from '@mui/icons-material/Edit';
//
// export function calculateAge(dateString) {
//     if (!dateString) return '';
//     const today = new Date();
//     const birthDate = new Date(dateString);
//     let age = today.getFullYear() - birthDate.getFullYear();
//     const m = today.getMonth() - birthDate.getMonth();
//     if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
//         age--;
//     }
//     return age;
// }
//
// const uploadImageToCloudinary = async (file) => {
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("upload_preset", "profilePics");
//     formData.append("cloud_name", "dyjdd8hcc");
//
//     const response = await fetch("https://api.cloudinary.com/v1_1/dyjdd8hcc/image/upload", {
//         method: "POST",
//         body: formData,
//     });
//
//     const data = await response.json();
//     return data.secure_url;
// };
//
// const ProfilePage = ({ profileId, canRequestJoin, onClose, isPopup = false }) => {
//     const uid = localStorage.getItem('uid');
//     const [profile, isLoadingProfile] = useDocumentData(doc(getFirestore(), 'users', profileId || uid));
//     const [isEditing, setIsEditing] = useState(false);
//     const [editedProfile, setEditedProfile] = useState(profile);
//     const coverInputRef = useRef();
//
//     const handleSave = async (newProfile, profileImage, coverImageFile) => {
//         Swal.fire({
//             title: "האם את/ה רוצה לשמור את השינויים?",
//             showDenyButton: true,
//             confirmButtonText: "שמור",
//             denyButtonText: `אל תשמור`,
//             customClass: {
//                 confirmButton: 'swal2-confirm-green',
//                 denyButton: 'swal2-deny-default'
//             }
//         }).then(async (result) => {
//             if (result.isConfirmed) {
//                 if (profileImage?.current) {
//                     try {
//                         const file = profileImage.current;
//                         const imageUrl = await uploadImageToCloudinary(file);
//                         newProfile.image = imageUrl;
//                     } catch (error) {
//                         console.error("שגיאה בהעלאת תמונת פרופיל", error);
//                         Swal.fire("שגיאה בהעלאת תמונת פרופיל", "", "error");
//                         return;
//                     }
//                 }
//                 if (coverImageFile?.current) {
//                     try {
//                         const file = coverImageFile.current;
//                         const coverUrl = await uploadImageToCloudinary(file);
//                         newProfile.coverImage = coverUrl;
//                     } catch (error) {
//                         console.error("שגיאה בהעלאת תמונת רקע", error);
//                         Swal.fire("שגיאה בהעלאת תמונת רקע", "", "error");
//                         return;
//                     }
//                 }
//
//                 newProfile.isRegistered = true;
//                 await setDoc(doc(getFirestore(), 'users', uid), newProfile);
//                 Swal.fire("נשמר!", "", "success");
//                 setIsEditing(false);
//             } else if (result.isDenied) {
//                 Swal.fire("השינויים לא נשמרו", "", "info");
//                 setEditedProfile(profile);
//                 setIsEditing(false);
//             }
//         });
//     };
//
//     const handleCoverImageChange = async (e) => {
//         const file = e.target.files[0];
//         if (!file) return;
//
//         try {
//             const coverUrl = await uploadImageToCloudinary(file);
//             await setDoc(doc(getFirestore(), 'users', uid), { ...profile, coverImage: coverUrl });
//             Swal.fire("תמונת הרקע עודכנה!", "", "success");
//         } catch (error) {
//             console.error("שגיאה בהעלאת תמונת רקע", error);
//             Swal.fire("שגיאה בהעלאת תמונת רקע", "", "error");
//         }
//     };
//
//     return isLoadingProfile ? (<div>loading...</div>) : (
//         <div dir="rtl" className="profile-page-container" style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'flex-start' }}>
//             <div className="profile-card">
//                 <div className="cover-photo-container" style={{ position: 'relative' }}>
//                     <img src={profile.coverImage} alt="Cover" className="cover-photo" />
//                     {profile.id === uid && !isPopup && (
//                         <>
//                             <IconButton
//                                 sx={{
//                                     position: 'absolute',
//                                     top: 8,
//                                     left: 8,
//                                     backgroundColor: 'rgba(255,255,255,0.7)',
//                                     width: 32,
//                                     height: 32,
//                                     padding: 0
//                                 }}
//                                 onClick={() => coverInputRef.current.click()}
//                             >
//                                 <EditIcon fontSize="small" />
//                             </IconButton>
//                             <input
//                                 type="file"
//                                 accept="image/*"
//                                 ref={coverInputRef}
//                                 hidden
//                                 onChange={handleCoverImageChange}
//                             />
//                         </>
//                     )}
//                 </div>
//
//                 <div className="profile-info-flex">
//                     <div className="profile-top-row">
//                         <div className="profile-img-container">
//                             <CachedImage src={profile.image} className={"profile-img"} />
//                         </div>
//                         <div className="profile-title-row">
//                             <h2 className="profile-name">{profile.title}</h2>
//                             {profile.id === uid && !isPopup && (
//                                 <div className="edit-button-container">
//                                     <button className="edit-profile-button" onClick={() => {
//                                         setEditedProfile(profile);
//                                         setIsEditing(true);
//                                     }}>
//                                         עריכת הפרופיל
//                                     </button>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//
//                     <div className="profile-basic-info">
//                         <div className="profile-summary-wrapper">
//                             <p className="profile-summary-line">
//                                 <strong>גיל:</strong> {calculateAge(dayjs(profile.birthDate))} |
//                                 <strong> מקום מגורים:</strong> {profile.location} |
//                                 <strong> תחומי עניין:</strong> {profile.interests}
//                             </p>
//                             <p className="profile-summary-line">
//                                 <strong>אזורי טיול מועדפים:</strong> {profile.favorite_trip_locations.join(", ")} |
//                                 <strong> סגנון טיולים אהוב:</strong> {profile.favorite_trip_styles.join(", ")}
//                             </p>
//                         </div>
//                     </div>
//                 </div>
//
//                 <div className="profile-body">
//                     <div className="profile-section">
//                         <h4>קצת עליי</h4>
//                         <p>{profile.about}</p>
//                     </div>
//
//                     <div className="profile-section">
//                         <h4>טיולים שאהבתי</h4>
//                         <div className="trips-list profile-trips-list">
//                             {profile.favoriteTrips.map((trip, idx) => (
//                                 <TripPreview key={idx} trip={trip} />
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//
//             {isEditing && (
//                 <EditUserProfile
//                     editedProfile={editedProfile}
//                     onSave={handleSave}
//                     onExit={() => setIsEditing(false)}
//                 />
//             )}
//         </div>
//     );
// };
//
// export default ProfilePage;




import React, { useRef, useState } from 'react';
import './Profile.css';
import TripPreview from '../components/TripPreview';
import Swal from 'sweetalert2';
import { doc, getFirestore, setDoc } from 'firebase/firestore';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import EditUserProfile from '../components/EditUserProfile';
import { IconButton } from '@mui/material';
import dayjs from 'dayjs';
import CachedImage from '../components/CachedImage';
import EditIcon from '@mui/icons-material/Edit';

export function calculateAge(dateString) {
    if (!dateString) return '';
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

const uploadImageToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "profilePics");
    formData.append("cloud_name", "dyjdd8hcc");

    const response = await fetch("https://api.cloudinary.com/v1_1/dyjdd8hcc/image/upload", {
        method: "POST",
        body: formData,
    });

    const data = await response.json();
    return data.secure_url;
};

const ProfilePage = ({ profileId, canRequestJoin, onClose, isPopup = false }) => {
    const uid = localStorage.getItem('uid');
    const [profile, isLoadingProfile] = useDocumentData(doc(getFirestore(), 'users', profileId || uid));
    const [isEditing, setIsEditing] = useState(false);
    const [editedProfile, setEditedProfile] = useState(profile);
    const coverInputRef = useRef();
    const [showAllPhotos, setShowAllPhotos] = useState(false);
    const tripPhotos = profile?.tripPhotos || [];

    const handleSave = async (newProfile, profileImage, coverImageFile) => {
        Swal.fire({
            title: "האם את/ה רוצה לשמור את השינויים?",
            showDenyButton: true,
            confirmButtonText: "שמור",
            denyButtonText: `אל תשמור`,
            customClass: {
                confirmButton: 'swal2-confirm-green',
                denyButton: 'swal2-deny-default'
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                // בדיקת travelPitch: חייב להיות עד 5 מילים
                const pitch = (newProfile.travelPitch || '').trim();
                const wordCount = pitch === '' ? 0 : pitch.split(/\s+/).length;

                if (pitch === '' || wordCount > 5) {
                    Swal.fire('יש למלא את השדה "כדאי לטייל איתי כי" עד 5 מילים בלבד', '', 'warning');
                    return;
                }

                if (profileImage?.current) {
                    try {
                        const file = profileImage.current;
                        const imageUrl = await uploadImageToCloudinary(file);
                        newProfile.image = imageUrl;
                    } catch (error) {
                        console.error("שגיאה בהעלאת תמונת פרופיל", error);
                        Swal.fire("שגיאה בהעלאת תמונת פרופיל", "", "error");
                        return;
                    }
                }

                if (coverImageFile?.current) {
                    try {
                        const file = coverImageFile.current;
                        const coverUrl = await uploadImageToCloudinary(file);
                        newProfile.coverImage = coverUrl;
                    } catch (error) {
                        console.error("שגיאה בהעלאת תמונת רקע", error);
                        Swal.fire("שגיאה בהעלאת תמונת רקע", "", "error");
                        return;
                    }
                }

                newProfile.isRegistered = true;
                await setDoc(doc(getFirestore(), 'users', uid), newProfile);
                Swal.fire("נשמר!", "", "success");
                setIsEditing(false);
            } else if (result.isDenied) {
                Swal.fire("השינויים לא נשמרו", "", "info");
                setEditedProfile(profile);
                setIsEditing(false);
            }
        });
    };


    const handleCoverImageChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            const coverUrl = await uploadImageToCloudinary(file);
            await setDoc(doc(getFirestore(), 'users', uid), { ...profile, coverImage: coverUrl });
            Swal.fire("תמונת הרקע עודכנה!", "", "success");
        } catch (error) {
            console.error("שגיאה בהעלאת תמונת רקע", error);
            Swal.fire("שגיאה בהעלאת תמונת רקע", "", "error");
        }
    };

    return isLoadingProfile ? (<div>loading...</div>) : (
        <div dir="rtl" className="profile-page-container" style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'flex-start' }}>
            <div className="profile-card">
                <div className="cover-photo-container" style={{ position: 'relative' }}>
                    <img src={profile.coverImage} alt="Cover" className="cover-photo" />
                    {profile.id === uid && !isPopup && (
                        <>
                            <IconButton
                                sx={{
                                    position: 'absolute',
                                    top: 8,
                                    left: 8,
                                    backgroundColor: 'rgba(255,255,255,0.7)',
                                    width: 32,
                                    height: 32,
                                    padding: 0
                                }}
                                onClick={() => coverInputRef.current.click()}
                            >
                                <EditIcon fontSize="small" />
                            </IconButton>
                            <input
                                type="file"
                                accept="image/*"
                                ref={coverInputRef}
                                hidden
                                onChange={handleCoverImageChange}
                            />
                        </>
                    )}
                </div>

                <div className="profile-info-flex">
                    <div className="profile-top-row">
                        <div className="profile-img-container">
                            <CachedImage src={profile.image} className={"profile-img"} />
                        </div>
                        <div className="profile-title-row">
                            <h2 className="profile-name">{profile.title}</h2>
                            {profile.id === uid && !isPopup && (
                                <div className="edit-button-container">
                                    <button className="edit-profile-button" onClick={() => {
                                        setEditedProfile(profile);
                                        setIsEditing(true);
                                    }}>
                                        עריכת הפרופיל
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="profile-basic-info">
                        <div className="profile-summary-wrapper">
                            <p className="profile-summary-line">
                                <strong>גיל:</strong> {calculateAge(dayjs(profile.birthDate))} |
                                <strong> מקום מגורים:</strong> {profile.location}
                                {profile.travelPitch && (
                                    <> | <strong>כדאי לטייל איתי כי</strong> {profile.travelPitch}</>
                                )} |
                                <strong> תחומי עניין:</strong> {profile.interests}
                            </p>


                            <p className="profile-summary-line">
                                <strong>אני אוהב/ת לטייל באזורים:</strong> {profile.favorite_trip_locations.join(", ")} |
                                <strong> סגנון טיולים אהוב:</strong> {profile.favorite_trip_styles.join(", ")}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="profile-body">
                    <div className="profile-section">
                        <h4>קצת עליי</h4>
                        <p>{profile.about}</p>
                    </div>

                    <div className="profile-section">
                        <h4>תמונות מטיולי עבר</h4>
                        <div className="profile-trip-photo">
                            {(tripPhotos.length <= 5
                                ? tripPhotos
                                : tripPhotos.slice(0, 4)
                            ).map((url, idx) => (
                                <img
                                    key={idx}
                                    src={url}
                                    alt={`טיול ${idx + 1}`}
                                    className="trip-photo-user"
                                />
                            ))}

                            {tripPhotos.length > 5 && (
                                <button
                                    className="view-all-photos-button"
                                    onClick={() => setShowAllPhotos(true)}
                                >
                                    צפייה בכל התמונות
                                </button>
                            )}
                        </div>




                    </div>
                </div>
            </div>

            {isEditing && (
                <EditUserProfile
                    editedProfile={editedProfile}
                    onSave={handleSave}
                    onExit={() => setIsEditing(false)}
                />
            )}

            {showAllPhotos && (
                <div className="popup-overlay" onClick={() => setShowAllPhotos(false)}>
                    <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                        <h2>כל התמונות מטיולי עבר</h2>
                        <div className="all-trip-photos">
                            {tripPhotos.map((url, idx) => (
                                <img
                                    key={idx}
                                    src={url}
                                    alt={`טיול ${idx + 1}`}
                                    className="trip-photo-full"
                                />
                            ))}

                        </div>
                        <button
                            className="close-button"
                            onClick={() => setShowAllPhotos(false)}
                        >
                            ✖
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProfilePage;
